<template>
	<div class="logo">
		<img v-if="theme === 'light'" height="144" src="@/assets/bf-logo-light.png" alt="Black Friday logo" />
		<img v-if="theme === 'dark'" height="144" src="@/assets/bf-logo-dark.png" alt="Black Friday logo" />
	</div>
</template>

<script>
export default {
	name: 'BlackFridayLogo',
	props: {
		theme: {
			type: String,
			default: 'light',
			validator: (value) => ['light', 'dark'].includes(value)
		}
	}
}
</script>

<style scoped lang="scss">
.logo {
	max-width: 300px;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	padding-top: 1.5rem;

	img {
		min-width: 144px;
	}
}
</style>
